import View from "./View";
import Presentor from "./Presentor";
import Model from "./Model";
import {inject} from "../../../../../../../Utils/Injector";

const exp = inject(View, Presentor, Model);


export default exp;
